import React from "react";
import { useI18n } from "@/lib/i18n";
import { IDR } from "@/lib/format";

/** Discounted price with the struck-through original and a saving badge. */
export const PlanPrice = ({ plan, testId }) => {
  const { t } = useI18n();
  const original = Number(plan.original_price_idr || 0);
  const price = Number(plan.price_idr || 0);
  const discounted = original > price;
  const pct = discounted ? Math.round(((original - price) / original) * 100) : 0;

  return (
    <div data-testid={testId}>
      <div className="flex flex-wrap items-baseline gap-3">
        <p className="font-mono-accent text-2xl text-[#D4AF37]">{IDR(price)}</p>
        {discounted && (
          <span className="font-mono-accent text-[10px] tracking-[0.14em] uppercase border border-[#D4AF37]/50 bg-[#D4AF37]/[0.08] text-[#D4AF37] px-2 py-1"
            data-testid={testId ? `${testId}-bonus` : undefined}>
            {t("bonus_pct", { pct })}
          </span>
        )}
      </div>
      {discounted ? (
        <p className="mt-1.5 text-xs text-[#707070]">
          <span className="line-through">{IDR(original)}</span>{" "}
          <span className="text-[#5A5A5A]">
            {plan.interval_months >= 12 ? t("per_year") : t("per_month")}
          </span>
        </p>
      ) : (
        <p className="mt-1 text-xs text-[#707070]">
          {plan.interval_months >= 12 ? t("per_year") : t("per_month")}
        </p>
      )}
    </div>
  );
};
